export default "__VITE_ASSET__CJqn0V5R__"